// @flow

export const MessageState = {
    ACKED: "ACKED",
    LOADING: "LOADING",
    FAILED: "FAILED",
};
